(function(angular) {
    'use strict';

    angular.module('core').controller('AuthLoopbackController', [
        '$stateParams',
        '$window',
        '$scope',
        '$log',
        'bmTokenStorage',
        'bmAnalyticsService',
        'AuthenticatedSessionData',
        function($stateParams, $window, $scope, $log, bmTokenStorage, bmAnalyticsService, authenticatedSessionData) {

            var jwt = null;

            function generateJWT() {
                if (!jwt) {
                    var token = bmTokenStorage.get();
                    if (!token) {
                        $log.error('No token available for JWT generation');
                        return null;
                    }

                    // Synchronous XHR for immediate redirect (intentional)
                    var xhr = new $window.XMLHttpRequest();
                    xhr.open('POST', '/api/security/v1/jwt/sessions', false);
                    xhr.setRequestHeader('Authorization', 'UDSLongToken ' + token);
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4 && xhr.status === 201) {
                            jwt = JSON.parse(xhr.responseText).token;
                        }
                    };
                    xhr.send();
                }
                return jwt;
            }

            function launchRedirect(url) {
                bmAnalyticsService.track('External App Launched', {
                    app: 'Applications.OnvioBRSupport',
                    url: url,
                    label: 'appLaunch'
                });
                $window.location.href = url;
            }

            function performLoopback() {
                var path = $stateParams.path;
                var decodedPath = path ? decodeURIComponent(path) : '';

                // Get the Support URL from session bindings
                authenticatedSessionData.getBindings().then(function(bindings) {
                    var supportUrl = bindings.RoutingTable.OnvioBRSupport;

                    if (!supportUrl) {
                        $log.error('Support URL not found in session bindings');
                        launchRedirect('/');
                        return;
                    }

                    // Build final URL: Support URL + JWT token (with optional path)
                    var jwtToken = generateJWT();
                    var finalUrl = supportUrl + '?token=' + jwtToken;

                    // Add path parameter only if provided and valid
                    if (decodedPath && decodedPath.trim() !== '') {
                        finalUrl += '&path=' + encodeURIComponent(decodedPath);
                    }

                    launchRedirect(finalUrl);
                }).catch(function(error) {
                    $log.error('Failed to get session bindings:', error);
                    launchRedirect('/');
                });
            }

            performLoopback();
        }
    ]);

})(window.angular);
